import 'core-js/es6/map';
import 'core-js/es6/set';

import React from 'react';
import ReactDOM from 'react-dom';

import { configure } from 'enzyme';
import Adapter from 'enzyme-adapter-react-16';

configure({ adapter: new Adapter() });

export default function MyAlert(props) {
    return (
        <div id="myAlert" className="invisible">
            <div className="myAlertBox">
                <div className="putAlertHere"></div>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./js/components/myalert.js